module.exports = __webpack_public_path__ + "media/new-pdf-report-layout/ubezpieczenie-komunikacyjne@2x-9dd17e3a.png";